import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'

import './css/styles.scss'

import AppClass from './../../../../../../../../js/classes/App'
import DomClass from './../../../../../../../../js/classes/Dom'
import OrderClass from './../../../../../../../../js/classes/Order'

const validatePhone = (value) => {
    if (value.length === 18 && value.indexOf('_') === -1) {
        return
    } else {
        return 'Некорректный номер телефона'
    }
}

const OneClickSchema = Yup.object().shape({
    FULL_NAME: Yup.string()
        .max(200, 'Слишком длинное Ф.И.О.')
        .required('Укажите Ф.И.О.'),

    PHONE: Yup.string()
        .required('Укажите номер телефона'),

    ADDRESS: Yup.string()
        .max(3500, 'Слишком длинный адрес')
        .required('Укажите адрес'),

    EMAIL: Yup.string()
        .email('Некорректный электронный адрес')
        .required('Укажите электронный адрес'),
})

const OrderOneClickApp = () => {
    const [ isShow, setShow ] = useState(false),
    [ notification, setNotification ] = useState(null),
    [ classes, setClasses ] = useState([])

    const handleClose = () => {
        setShow(false)
    },
    handleSubmit = (values) => {
        const data = {
            ...values, 
            LINK : document.location.protocol + '//' + document.location.host + document.location.pathname
        }

        OrderClass.sendOneClick((err, res) => {
            if (res) {
                setNotification({
                    title : 'Заказ отправлен!',
                    message : 'Мы с Вами скоро свяжемся для уточнения всех деталей.'
                })
            } else {
                setNotification({
                    title : 'Произошла ошибка ;(',
                    message : 'Пожалуйста позвоните по телефону +7 (499) 347-63-48'
                })
            }
        }, data)
    }

    useEffect(() => {
        const phoneInput = document.getElementById('oneclick-formix-phone')

        DomClass.setMask(phoneInput)

        AppClass.addCallback('SHOW_ONE_CLICK_POPUP', () => {
            setShow(true)
        })
    }, [])

    useEffect(() => {
        const _classes = ['happy-order__oneclick']

        if (isShow) {
            _classes.push('happy-order__oneclick_show')
        }

        setClasses(_classes)
    }, [ isShow ])

    return <div className={ classes.join(' ') }>
        <div className="happy-order__oneclick-blackmask" onClick={ handleClose }></div>

        <div className="happy-order__oneclick-content">
            <span className="happy-order__oneclick-close" onClick={ handleClose }></span>

            { notification ? (<>
                <div className="happy-order__oneclick-title">{ notification.title }</div>

                <div className="happy-order__oneclick-text">
                    { notification.message }
                </div>
            </>) : (<>
                <div className="happy-order__oneclick-title">Заказ в 1 клик!</div>

                <div className="happy-order__oneclick-text"></div>

                <Formik
                    initialValues={{
                        FULL_NAME : '',
                        PHONE : '',
                        ADDRESS : '',
                        EMAIL : '',
                    }}
                    validationSchema={ OneClickSchema }
                    onSubmit={ handleSubmit }
                >
                    {({ errors, touched }) => (
                        <Form className="form">
                            <div className="form__rows">
                                <div className="form__row">
                                    <Field
                                        name="FULL_NAME"
                                        className="form__input"
                                        placeholder="Ф.И.О."
                                    />
                                    { errors.FULL_NAME && touched.FULL_NAME && (
                                        <div className="form__valid-text">{ errors.FULL_NAME }</div>
                                    ) }
                                </div>

                                <div className="form__row">
                                    <Field
                                        name="PHONE"
                                        className="form__input"
                                        placeholder="+7 (___) ___-__-__"
                                        validate={ validatePhone }
                                        id="oneclick-formix-phone"
                                    />
                                    { errors.PHONE && touched.PHONE && (
                                        <div className="form__valid-text">{ errors.PHONE }</div>
                                    ) }
                                </div>

                                <div className="form__row">
                                    <Field
                                        name="ADDRESS"
                                        as="textarea"
                                        className="form__input"
                                        placeholder="Адрес"
                                    />
                                    { errors.ADDRESS && touched.ADDRESS && (
                                        <div className="form__valid-text">{ errors.ADDRESS }</div>
                                    ) }
                                </div>

                                <div className="form__row">
                                    <Field
                                        name="EMAIL"
                                        type="email"
                                        className="form__input"
                                        placeholder="Электронная почта"
                                    />
                                    { errors.EMAIL && touched.EMAIL && (
                                        <div className="form__valid-text">{ errors.EMAIL }</div>
                                    ) }
                                </div>
                            </div>

                            <div className="form__submit">
                                <button className="button button_big" type="submit">Заказать</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </>) }
        </div>
    </div>
}

const container = document.getElementById('root-order-one-click-container')

if (container) ReactDOM.render(<OrderOneClickApp />, container)